import { updateProfile } from "firebase/auth";

const UpdateProfileFunction = (user,name,image) => {
    
    updateProfile(user, {
          displayName: name,
          photoURL: image,
        });

}

export default UpdateProfileFunction;